<template>

  <autocomplete
    :items="allOptions"
    @update-items="updateItems"
    :value="value"
    @change="input"
    @input="input"
    :auto-select-one-item="false"
    :placeholder="placeholder">
    </autocomplete>

</template>

<script>
import Autocomplete from 'v-autocomplete'

export default {
  name: 'InputAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    'value': {
      type: String,
      default: null
    },
    'placeholder': {
      type: String,
      default: ''
    },
    'options': {
      type: Array,
      edfault: () => { return [] }
    },
    'minLength': {
      type: Number,
      default: 2
    },
    'type': {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      requestOptions: [],
      show: false
    }
  },
  computed: {
    allOptions () {
      return this.options.concat(this.requestOptions)
    },
    optionsFiltered () {
      if (this.value) {
        return this.searchInArray(this.allOptions, this.value).slice(0, 10)
      } else {
        return this.options.slice(0, 10)
      }
    }
  },
  mounted () {
  },
  methods: {
    updateItems (text) {
      return this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/autocomplete/addresses', {params: {q: text}})
      .then((response) => {
        this.requestOptions = response.data
      })
    },
    input (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-autocomplete {
  position: relative;
  .v-autocomplete-input-group {
    .v-autocomplete-input {
      font-size: 1em;
      padding: .375rem .75rem;
      box-shadow: none;
      border: 1px solid #ced4da;
      width: 100%;
      outline: none;
      background-color: #ffffff;
      border-radius: 3px;
      color: rgb(73, 80, 87);
    }
    /*
    &.v-autocomplete-selected {
      .v-autocomplete-input {
        color: green;
        background-color: #f2fff2;
      }
    }
    */
  }
  .v-autocomplete-list {
    position: absolute;
    z-index: 2;
    width: 100%;
    border: none;
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ced4da;
    .v-autocomplete-list-item {
      cursor: pointer;
      background-color: #fff;
      padding: 5px 10px;
      border-bottom: 1px solid #ced4da;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background-color: #eee;
      }
      &.v-autocomplete-item-active {
        background-color: #eee;
      }
      abbr {
        opacity: 0.8;
        font-size: 0.8em;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputAutocomplete.vue